// Fade in on load
$(document).ready(function () {
    $("header").fadeIn(2000);
});

$(window).load(function () {
    $("#preload-overlay").addClass("no-bg-img");
    $("#preload-overlay").fadeOut(2000); 
});  



// MAIN NAV MENUS
// click buttons to pull in menus from left 
// click 'shop' to open and close main menu    
$(document).ready(function () {
	$("#menu-slide-button > a").on("click", function(e){
			e.preventDefault();
		if($("#nav-slider").hasClass("closed-slide")) {
			$("#nav-slider").addClass("open-slide");
            $("#nav-slider").removeClass("closed-slide");
            $("body").addClass("active-menu");
            $("#sleep-tight").addClass("sleep-tight-active");
            $("#menu-slide-button").addClass("shop-menu-color");
            $("#learn-slide-button").removeClass("shop-menu-color");
            $(".product-do").removeClass("come-forward");
            $("#learn-slider").addClass("closed-slide");
            $("#learn-slider").removeClass("open-slide");
            $("#nav-slider").fadeIn(1);
            $("#nav-wrappers").removeClass("closed-wrappers");
            $("#mobile-menu-switchers").removeClass("closed-wrappers");
		}
		else if($("#nav-slider").hasClass("open-slide")) {
			$("#nav-slider").addClass("closed-slide");
            $("#nav-slider").removeClass("open-slide");
            $("body").removeClass("active-menu");
            $("#sleep-tight").removeClass("sleep-tight-active");
            $("#menu-slide-button").removeClass("shop-menu-color");
		}
	});
});

// click 'learn' to open and close learn menu    
$(document).ready(function () {
	$("#learn-slide-button > a").on("click", function(e){
			e.preventDefault();
		if($("#learn-slider").hasClass("closed-slide")) {
			$("#learn-slider").addClass("open-slide");
            $("#learn-slider").removeClass("closed-slide");
            $("body").addClass("active-menu");
            $("#sleep-tight").addClass("sleep-tight-active");
            $("#learn-slide-button").addClass("shop-menu-color");
            $("#menu-slide-button").removeClass("shop-menu-color");
            $(".product-do").removeClass("come-forward");
            $("#nav-slider").addClass("closed-slide");
            $("#nav-slider").removeClass("open-slide");
            $("#learn-slider").fadeIn(1);
            $("#nav-wrappers").removeClass("closed-wrappers");
            $("#mobile-menu-switchers").removeClass("closed-wrappers");
		}
		else if($("#learn-slider").hasClass("open-slide")) {
			$("#learn-slider").addClass("closed-slide");
            $("#learn-slider").removeClass("open-slide");
            $("body").removeClass("active-menu");
            $("#sleep-tight").removeClass("sleep-tight-active");
            $("#learn-slide-button").removeClass("shop-menu-color");
		}
	});
});


// close menus 
// close MENU when x in menu is clicked    
$(document).ready(function () {
	$("#menu-close-button").on("click", function(e){
			$("#nav-slider").addClass("closed-slide");
            $("#nav-slider").removeClass("open-slide");
            $("#sleep-tight").removeClass("sleep-tight-active");
            $("#menu-slide-button").removeClass("shop-menu-color");
            $("body").removeClass("active-menu");
	});
}); 

// close LEARN when x in menu is clicked    
$(document).ready(function () {
	$("#learn-close-button").on("click", function(e){
			$("#learn-slider").addClass("closed-slide");
            $("#learn-slider").removeClass("open-slide");
            $("#sleep-tight").removeClass("sleep-tight-active");
            $("#learn-slide-button").removeClass("shop-menu-color");
            $("body").removeClass("active-menu");
	});
}); 

// close menu when links in menu are clicked    
$(document).ready(function () {
	$("#slide-out-menu > a").on("click", function(e){
			$("#nav-slider").addClass("closed-slide");
            $("#nav-slider").removeClass("open-slide");
            $("#learn-slider").addClass("closed-slide");
            $("#learn-slider").removeClass("open-slide");
            $("#sleep-tight").removeClass("sleep-tight-active");
            $("#menu-slide-button").removeClass("shop-menu-color");
            $("#learn-slide-button").removeClass("shop-menu-color");
            $("body").removeClass("active-menu");
	});
});

// close menu when overlay is clicked    
$(document).ready(function () {
	$("#sleep-tight").on("click", function(e){
			$("#nav-slider").addClass("closed-slide");
            $("#nav-slider").removeClass("open-slide");
            $("#learn-slider").addClass("closed-slide");
            $("#learn-slider").removeClass("open-slide");
            $("#sleep-tight").removeClass("sleep-tight-active");
            $("#menu-slide-button").removeClass("shop-menu-color");
            $("#learn-slide-button").removeClass("shop-menu-color");
            $("body").removeClass("active-menu");
            $(".product-do").removeClass("come-forward");
            $("#product-variants").removeClass("open");
            $("#product-variants").addClass("closed");
	});
});


// show main search
$(document).ready(function () {
	$("#main-search-button").on("click", function(e){
			e.preventDefault();
		if($("#main-search").hasClass("main-search-hide")) {
			$("#main-search").addClass("main-search-show");
            $("#main-search").removeClass("main-search-hide");
            $("#sleep-tight").addClass("sleep-tight-active");
            $("#search-box-focus").focus();
            
		}
		else if($("#main-search").hasClass("main-search-show")) {
			$("#main-search").addClass("main-search-hide");
            $("#main-search").removeClass("main-search-show");
            $("#sleep-tight").removeClass("sleep-tight-active");
		}
	});
});

// show main search (mobile)
$(document).ready(function () {
	$("#mobile-search").on("click", function(e){
			e.preventDefault();
		if($("#main-search").hasClass("main-search-hide")) {
			$("#main-search").addClass("main-search-show");
            $("#main-search").removeClass("main-search-hide");
            $("#sleep-tight-mobile").addClass("sleep-tight-active");
            $("#search-box-focus").focus();
            
		}
		else if($("#main-search").hasClass("main-search-show")) {
			$("#main-search").addClass("main-search-hide");
            $("#main-search").removeClass("main-search-show");
            $("#sleep-tight-mobile").removeClass("sleep-tight-active");
		}
	});
});

// close search when x in menu is clicked    
$(document).ready(function () {
	$("#main-search-close").on("click", function(e){
			$("#main-search").addClass("main-search-hide");
            $("#main-search").removeClass("main-search-show");
            $("#sleep-tight").removeClass("sleep-tight-active");
            $("#sleep-tight-mobile").removeClass("sleep-tight-active");
	});
});

// close main search when x in menu is clicked    
$(document).ready(function () {
	$("#main-search-close").on("click", function(e){
			$("#main-search").addClass("main-search-hide");
            $("#main-search").removeClass("main-search-show");
            $("#sleep-tight").removeClass("sleep-tight-active");
	});
});





// controling transformicon menu
$(document).ready(function () {
    var anchor = document.querySelectorAll('button');

    [].forEach.call(anchor, function(anchor){
        var open = false;
        anchor.onclick = function(event){
            event.preventDefault();
            if(!open){
                this.classList.add('close');
                $('#mobile-menu').addClass('mobile-menu-fixed');
                $('#mobile-menu').removeClass('mobile-menu-hover');
                $('body').addClass('active-menu');    
                $('#mobile-menu-switchers').removeClass('closed-wrappers');
                $('#nav-wrappers').removeClass('closed-wrappers');
                open = true;
            }
            else{
                this.classList.remove('close');
                $('#mobile-menu').removeClass('remove-bg');
                $('#mobile-menu').removeClass('mobile-menu-fixed');
                $('body').removeClass('active-menu');
                $('#mobile-menu-switchers').addClass('closed-wrappers');
                $('#nav-wrappers').addClass('closed-wrappers');
                $("#sleep-tight").removeClass("sleep-tight-active");
                open = false;
            }
        }
    }); 
});


// inner mobile menu
$(document).ready(function () {
    $("#mobile-shop").on("click", function(e){
			e.preventDefault();
		if($("#mobile-shop").hasClass("mobile-switch-unused")) {
			$("#mobile-shop").removeClass("mobile-switch-unused");
            $("#mobile-learn").addClass("mobile-switch-unused");
            $("#nav-slider").fadeIn(500);
            $("#learn-slider").fadeOut(500);
        }
     });   
});

$(document).ready(function () {
    $("#mobile-learn").on("click", function(e){
			e.preventDefault();
		if($("#mobile-learn").hasClass("mobile-switch-unused")) {
			$("#mobile-learn").removeClass("mobile-switch-unused");
            $("#mobile-shop").addClass("mobile-switch-unused");
            $("#learn-slider").fadeIn(500);
            $("#nav-slider").fadeOut(500);   
        }
    });
});


// make menu sticky
$(window).scroll(function(e){ 
    var $el = $('.header-bottom'); 
    var isPositionFixed = ($el.css('position') == 'fixed');
    if ($(this).scrollTop() > 50 && !isPositionFixed){ 
        $('.header-bottom').css({'position': 'fixed', 'top': '0px'});
        $("#cart-drawer-list").addClass("extended-drawer");
        $("#nav-slider").addClass("extended-nav");
        $("#learn-slider").addClass("extended-nav");
        $("#first").addClass("extended-first");
    }
    if ($(this).scrollTop() < 50 && isPositionFixed){
        $('.header-bottom').css({'position': 'static', 'top': '0px'});
        $("#cart-drawer-list").removeClass("extended-drawer");
        $("#nav-slider").removeClass("extended-nav");
        $("#learn-slider").removeClass("extended-nav");
        $("#first").removeClass("extended-first");
    } 
});




// show and hide product share    
$(document).ready(function () {
	$("#share-activate > a").on("click", function(e){
			e.preventDefault();
		if($("#share-activate").hasClass("share-closed")) {
			$("#share-activate").removeClass("share-closed");
            $("#share-activate").addClass("share-open");
            $("#share-activate").addClass("black-share");
            $("#product-delivery-buttons").addClass("product-share-buttons-hidden");
            $("#product-delivery-buttons").removeClass("product-share-buttons-shown");
            $("#product-share-buttons").removeClass("product-share-buttons-hidden");
            $("#product-share-buttons").addClass("product-share-buttons-shown");
		}
		else if($("#share-activate").hasClass("share-open")) {
			$("#share-activate").removeClass("share-open");
            $("#share-activate").addClass("share-closed");
            $("#share-activate").removeClass("black-share");
            $("#product-delivery-buttons").removeClass("product-share-buttons-hidden");
            $("#product-delivery-buttons").addClass("product-share-buttons-shown");
            $("#product-share-buttons").addClass("product-share-buttons-hidden");
            $("#product-share-buttons").removeClass("product-share-buttons-shown");
            

		}
	});
});

// slide up to show variants    
$(document).ready(function () {
	$("#product-variants").on("click", function(e){
            if($("#product-variants").hasClass("closed")) {
                $("#product-variants").removeClass("closed");
                $("#product-variants").addClass("open");
                $("#sleep-tight-invisible").addClass("sleep-tight-invisible-active");
                $("#product-do").addClass("come-forward");
                if($('#options').height() > 110){
                    $("#product-actions").addClass("product-actions-open-big");
                }
                else {
                    $("#product-actions").addClass("product-actions-open");
                }
            }
            else {
                $("#product-variants").removeClass("open");
                $("#product-variants").addClass("closed");
                $("#sleep-tight-invisible").removeClass("sleep-tight-invisible-active");
                $("#product-do").removeClass("come-forward");
                $("#product-actions").removeClass("product-actions-open-big");
                $("#product-actions").removeClass("product-actions-open");
            }   
    });
});

// close menu when overlay is clicked    
$(document).ready(function () {
	   $("#sleep-tight-invisible").on("click", function(e){
			$("#product-variants").removeClass("open");
            $("#product-variants").addClass("closed");
            $("#sleep-tight-invisible").removeClass("sleep-tight-invisible-active");
            $("#product-do").removeClass("come-forward");
            $("#product-actions").removeClass("product-actions-open-big");
            $("#product-actions").removeClass("product-actions-open");
	   });
});

// change class on out of stock variants
$(window).load(function () {
    $('.option').each(function(){
	var theHTML = $(this).html();
  if(theHTML.indexOf('nostock') > -1){
  	theHTML = theHTML.replace('nostock', '');
  	$(this).html(theHTML).addClass('out-of-stock-variant');
  }
});
});





// CART SLIDE DOWNS
// slide down and up cart drawer on hover
$(".cart-menu").on( {
    mouseenter: function() {
        $("#cart-drawer").removeClass("cart-drawer-hide");
        $("#cart-drawer").addClass("cart-drawer-show");
    },
    mouseleave: function() {
        $("#cart-drawer").removeClass("cart-drawer-show");
        $("#cart-drawer").addClass("cart-drawer-hide");
    }
});

$(".cart-drawer").on( {
    mouseenter: function() {
        $("#cart-drawer").removeClass("cart-drawer-hide");
        $("#cart-drawer").addClass("cart-drawer-show");
    },
    mouseleave: function() {
        $("#cart-drawer").removeClass("cart-drawer-show");
        $("#cart-drawer").addClass("cart-drawer-hide");
    }
});

// slide down and up cart drawer on product add to cart
$(document).on('cart.requestStarted', function(event, cart) {
    $("#cart-drawer").removeClass("cart-drawer-hide");
    $("#cart-drawer").addClass("cart-drawer-show");
    setTimeout(function () {
        $("#cart-drawer").removeClass("cart-drawer-show");
        $("#cart-drawer").addClass("cart-drawer-hide");
    }, 3500);
});


// script for preventing adding to cart until variant selected
$(window).load(function () {
	   $(".option").on("click", function(e){
			$("#prevent").addClass("hidden-preventor");
	   });
});

$(window).load(function () {
	   $("option").on("click", function(e){
			$("#prevent").addClass("hidden"); 
	   });
});


// SIMPLE SELECT

// simple select initiation
$(document).ready(function(){
    $("select").simpleselect();
});




// SLICK SLIDER
// index page main slider
$(document).ready(function(){
    $('.index-slider').slick({
        accessibility: false,
        arrows: true,
        speed: 1000
  });
}); 

// product images main slider
$(document).ready(function(){
    $('.product-slider').slick({
        accessibility: false,
        arrows: true,
        fade: true,
        speed: 500
  });  
}); 





// SLY SLIDER
/*global Sly */

var mySlySlider;

jQuery(function ($) {
    'use strict';

    var frame = $('.frame');

    mySlySlider = new Sly(frame, {
        horizontal: 1,
        itemNav: 'centered',
        itemSelector: ':visible',
        smart: true,
        activateOn: 'click',
        scrollBy: 1,
        mouseDragging: 1,
        touchDragging: 1,
        swingSpeed: 0.2,
        scrollBar: $('.scrollbar'),
        dragHandle: 1,
        speed: 600,
        startAt: 0
        }).init();

    $(window).load(function () {
        mySlySlider.reload();
    });
    
    $(window).on('resize', function () {
        mySlySlider.reload();
    });
});


// END FORCING

// get slide of slides for slick slides (index)
$(document).ready(function(){
    var $statusSlide = $('.status-slide');
    var $statusOf = $('.status-of');
    var $slickElement = $('.index-slider');

    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        var sc = ($slickElement).slick("getSlick").slideCount;
        $statusSlide.text(i);
        $statusOf.text(sc);
    });

    $slickElement.slick({
        slide: 'img',
        autoplay: true,
        dots: true
    });
});

// get slide of slides for slick slides (product)
$(document).ready(function(){
    var $statusSlide = $('.status-slide-prod');
    var $statusOf = $('.status-of-prod');
    var $slickElement = $('.product-slider');

    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        var sc = ($slickElement).slick("getSlick").slideCount;
        $statusSlide.text(i);
        $statusOf.text(sc);
    });

    $slickElement.slick({
        slide: 'img',
        autoplay: true,
        dots: true
    });
});
 


$(window).load(function () {
    setTimeout(function(){
        mySlySlider.reload();
    }, 2000);
});

$(window).on('resize', function () {
    mySlySlider.reload();
});